export default "__VITE_ASSET__59f175bd__"